import React from 'react'
import AddToMemoryComp from './AddToMemoryComp'
import MemoryHistoryListComp from './MemoryHistoryListComp'
import "./memoryCont.css"

function MemoryContainerSC({memoryType="Global"}) {
  return (
    <div className='mem-container-sc'>
        <AddToMemoryComp memoryType={memoryType}/>
        <MemoryHistoryListComp memoryType={memoryType}/>
    </div>
  )
}

export default MemoryContainerSC